import React, { useRef } from "react";
import Navbar from "./components/Navbar";
import Home from "./pages/Home";
import Events from "./pages/Events";
import PrayerTimes from "./pages/PrayerTimes";
import About from "./pages/About";
import Footer from "./components/Footer";
import { LanguageProvider } from "./LanguageContext";

function App() {
  // Create references for each section
  const homeRef = useRef(null);
  const eventsRef = useRef(null);
  const prayerRef = useRef(null);
  const aboutRef = useRef(null);

  // Smooth scroll handler
  const scrollToSection = (ref) => {
    ref.current?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <div className="flex flex-col min-h-screen">
      {/* Pass scroll function to navbar */}
      <Navbar
        onHomeClick={() => scrollToSection(homeRef)}
        onEventsClick={() => scrollToSection(eventsRef)}
        onPrayerClick={() => scrollToSection(prayerRef)}
        onAboutClick={() => scrollToSection(aboutRef)}
      />

      <main className="flex-grow" style={styles.main}>
        <section ref={homeRef} style={styles.section}><Home /></section>
        <section ref={eventsRef} style={styles.section}><Events /></section>
        <section ref={prayerRef} style={styles.section}><PrayerTimes /></section>
        <section ref={aboutRef} style={styles.section}><About /></section>
      </main>


      <Footer />
    </div>
  );
}

const styles = {
  main: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  section: {
    width: "100%",
    padding: "40px 0", // uniform top and bottom spacing
    scrollMarginTop: "20px", // ensures navbar doesn't cover section
  },
};

export default App;
